import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-cadastro-social-perimetro-final',
  templateUrl: './projeto-cadastro-social-perimetro-final.component.html',
  styleUrls: ['./projeto-cadastro-social-perimetro-final.component.scss'],
})
export class ProjetoCadastroSocialPerimetroFinalComponent { }
